import "../css/Header.css"
import "../css/common_mf.css"
import "../css/home_mf.css"
import * as React from "react";
import {
  AppBar, Box, Toolbar, Typography, MenuItem, IconButton, Button, Drawer, List,
  Divider, ListItem, ListItemButton, ListItemText, Link as Links
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import img_logo_w from "../images/logo_w.svg";
import img_logo from "../images/logo.svg";

/**
 * 一般画面のヘッダ
 * @returns 
 */
function HeaderGen() {
  const anchor = "left";
  const [state, setState] = React.useState({ left: false, });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };
  const location = useLocation();

  // メニューオープン
  const [isOpen, setIsOpen] = useState(false);

  const list = (anchor) => (
    <Box
      role="presentation"
      className="sideBar"
    >
      <List>
        {["海外の食品規則チェックサイト"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <IconButton className="cancelIcon" onClick={toggleDrawer(anchor, false)} size="large" edge="start" aria-label="menu" sx={{ mr: 2 }}>
                <CancelIcon />
              </IconButton>
              <ListItemText primary={text} primaryTypographyProps={{ variant: 'h6' }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["検索TOPへ"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["残留農薬チェック"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/D0121RacTop"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["EU食品添加物チェック"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/D0131FoodAdditive"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["初めての方へ"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/D006FirstTime"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["輸出要件・規制一覧"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/D007RoadMap"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["よくあるご質問"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/D00501QuestionList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["更新履歴"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/D008UpdateLog"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <br />
      <div className="text_a">
        <Links
          variant="body2"
          component={Link}
          to={"/D010TermsService"}
          onClick={toggleDrawer(anchor, false)}
        >
          利用規約・免責事項
        </Links>
        <a>&nbsp;／&nbsp;</a>
        <Links
          variant="body2"
          component={Link}
          to={"/D011PrivacyPolicy"}
          onClick={toggleDrawer(anchor, false)}
        >
          プライバシーポリシー
        </Links>
        <br />
        <br />
        <Button variant="contained" component={Link} to="./D0041ContactTop" onClick={toggleDrawer(anchor, false)}>
          お問合せ
        </Button>
        <br />
      </div>
      <br />
    </Box>
  );

  /**
   * スマホメニューのOpen/Close
   * @returns 
   */
  function MenuClick() {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  }

  return (
    <div>
      {/* <header className="header_pc">
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="fixed" color="inherit">
            <Toolbar>
              <Box>
                <IconButton className="displayIcon" onClick={toggleDrawer(anchor, true)} size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
                  <MenuIcon />
                </IconButton>
                <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
                  {list(anchor)}
                </Drawer>
              </Box>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                海外の食品規則チェックサイト
              </Typography>
            </Toolbar>
          </AppBar>
        </Box>
      </header>

      <header className="header_sp">
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="fixed" color="inherit">
            <Toolbar>
              <Box>
                <IconButton className="displayIcon" onClick={toggleDrawer(anchor, true)} size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
                  <MenuIcon />
                </IconButton>
                <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
                  {list(anchor)}
                </Drawer>
              </Box>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                海外の食品規則チェックサイト
              </Typography>
            </Toolbar>
          </AppBar>
        </Box>
      </header> */}
      <header id="header">
        <div class="headerInner">
          <div class="logo"><a href="./">
            <img src={img_logo_w} alt="海外の食品規則チェックサイト" class="forPC"/>
            <img src={img_logo} alt="海外の食品規則チェックサイト" class="forSP"/>
          </a></div>
          <div class={isOpen ? "menu isOpen" : "menu"} onClick={() => MenuClick()}>
            <span></span><span></span><span></span>
          </div>
          <nav style={isOpen ? { display: "block" } : {}}>
            <div class="gMenu">
              <ul>
                <li><a href="./"
                  class={location.pathname == "./" ? "current" : ""}
                >検索TOP</a></li>
                <li><a href="./D006FirstTime"
                  class={location.pathname.startsWith("/D006") ? "current" : ""}
                >初めての方へ</a></li>
                <li><a href="./D007RoadMap"
                  class={location.pathname.startsWith("/D007") ? "current" : ""}
                >輸出要件・規制一覧</a></li>
                <li><a href="./D00501QuestionList"
                  class={location.pathname.startsWith("/D005") ? "current" : ""}
                >よくあるご質問</a></li>
                <li><a href="./D008UpdateLog"
                  class={location.pathname.startsWith("/D008") ? "current" : ""}
                >更新履歴</a></li>
              </ul>
              <div class="headerContact"><a href="./D0041ContactTop">お問合せ</a></div>
            </div>
          </nav>
        </div>
      </header>

    </div>
  );
}

export default HeaderGen;
